import { createAsyncThunk } from '@reduxjs/toolkit';
import { Payment } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { FindPayment } from './interface';

export const findPayment = createAsyncThunk(
  'payment/findPayment',
  async (values: FindPayment, { rejectWithValue }) => {
    try {
      const response = await Payment.find({
        query: values,
      });

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);